import $ from 'jquery';

$(() => {
	const $select = $('.yco-custom-select2');
	const $orderPriceCointainer = '.wpcf7cf_repeater_controls';
	const ajaxUrl = window.agroAjax && window.agroAjax.ajaxurl ? window.agroAjax.ajaxurl : null;

	if ($select.length) {
		$select.select2();
	}

	const data = (key, value) => {
		const item = {};
		item[key] = value;
		return item;
	}

	$('<div>', { class: 'total', text: 'Összesen: ' }).appendTo($orderPriceCointainer);
	$('<span>', { class: 'total__text' }).appendTo(`${$orderPriceCointainer} .total`);

	const ajax = (responseData) => {
		$.ajax({
			type: 'post',
			dataType: 'json',
			url: ajaxUrl,
			data: {
				action: 'calculate_goods',
				data: responseData,
			},
			beforeSend: () => {
				$('<div>', { class: 'loader loading' }).appendTo('.wpcf7cf_repeater_controls')
			},
			success: (response) => {
				$('.total').show();
				$('.total span').html(response.total);
			},
			complete: () => {
				$('.loader').removeClass('loading');
			},
		});
	};

	const $form = $('.wpcf7-form');
	const datas = {};

	if ($form.length) {
		$form.on('wpcf7cf_repeater_added', (e) => {
			const $target = $(e.target);
			const $selectSub = $target.find('.yco-custom-select2');
			$selectSub.select2();
		});
	}

	$(document).on('change', '.yco-custom-select2', (e) => {
		const $this = $(e.currentTarget);
		const $op = $('option:selected', $this).attr('data-post-id');
		Object.assign(datas, data($this.attr('name'), $op));
	});

	$(document).on('change', 'input.selected-goods-qty', (e) => {
		const $this = $(e.currentTarget);
		Object.assign(datas, data($this.attr('name'), $this.val()));
		ajax(datas);
	});

	$(document).on('click', '.remove-this-row', (e) => {
		const $this = $(e.target);
		const $wrap = $this.closest('.wpcf7cf_repeater_sub');
		const $sel = $wrap.find('select.yco-custom-select2');
		const $input = $wrap.find('input.selected-goods-qty');
		delete datas[$($sel).attr('name')];
		delete datas[$($input).attr('name')];
		ajax(datas);
		wpcf7cf.repeaterRemoveSubAtIndex($form, 'product_rows', $wrap.index());
	});
});



// WEBPACK FOOTER //
// ./assets/scripts/product_order.js